/**
 * Head Scripts
 *
 * This module initializes scripts that need to run early in the page loading process.
 * It includes functionality for page redirects and language preferences.
 */

// Import modules
import { initPageRedirect } from './modules/page-redirect.js';
import { initLangPreference } from './modules/lang-preference.js';
import { initPolyfills } from './modules/polyfills.js';
import { initDataLayerUtils } from './modules/datalayer-utils.js';
import { initPageUtils } from './modules/page-utils.js';

// Initialize modules immediately
initPolyfills();
initDataLayerUtils();
initPageUtils();
initPageRedirect();
initLangPreference();

// Export functions for potential reuse
export {
    initPageRedirect,
    initLangPreference,
    initPolyfills,
    initDataLayerUtils
};
